import { defineComponent } from 'navigation-components/platform/models';
import { YEAR_IN_REVIEW_MODAL_COMPONENT } from '../constants';
import { getPortalId } from '../../common/utils';
import { capabilities } from '../../capabilities';
import { yearInReviewIframeStyle } from './internal/styles';
import { args } from '../../common/args';
export const yearInReviewModalComponentDef = defineComponent(YEAR_IN_REVIEW_MODAL_COMPONENT, {
  name: YEAR_IN_REVIEW_MODAL_COMPONENT,
  path: `/review-insights/${getPortalId()}/nav`,
  capabilities: [capabilities.RESTYLE_CAP.getName(), capabilities.HIDE_COMPONENT_CAP.getName()],
  iframeProps: {
    id: 'year-in-review-modal',
    style: yearInReviewIframeStyle
  },
  propsSchema: {
    source: args.string()
  },
  initialProps: {
    source: ''
  }
});